import de from "../locales/de.json";
import en from "../locales/en.json";
import fr from "../locales/fr.json";
import it from "../locales/it.json";

const translations = {
  de,
  en,
  fr,
  it,
};

export default translations;
